var map = {
	"./1.gif": 16,
	"./10.gif": 17,
	"./11.gif": 18,
	"./12.gif": 19,
	"./13.gif": 20,
	"./14.gif": 21,
	"./15.gif": 22,
	"./16.gif": 23,
	"./17.gif": 24,
	"./18.gif": 25,
	"./2.gif": 26,
	"./3.gif": 27,
	"./4.gif": 28,
	"./5.gif": 29,
	"./6.gif": 30,
	"./7.gif": 31,
	"./8.gif": 32,
	"./9.gif": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;